
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { RoleSelector } from "@/components/role-manager/RoleSelector";

type UserRole = 'admin' | 'user' | 'atc' | 'dm' | 'sales_assistant';

interface Role {
  role: UserRole;
}

interface RoleSelectionCardProps {
  availableRoles: Role[];
  selectedRole: UserRole | '';
  onRoleChange: (role: UserRole) => void;
  onSavePermissions: () => void;
  saving: boolean;
}

export const RoleSelectionCard = ({
  availableRoles,
  selectedRole,
  onRoleChange,
  onSavePermissions,
  saving
}: RoleSelectionCardProps) => {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Role Selection</CardTitle>
      </CardHeader>
      <CardContent>
        <RoleSelector 
          availableRoles={availableRoles}
          selectedRole={selectedRole}
          onRoleChange={onRoleChange}
          onSavePermissions={onSavePermissions}
          saving={saving}
        />
      </CardContent>
    </Card>
  );
};
